/**
 * Class description
 *
 * Created: 2019-08-29
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";

export class SAOverlayPresentation implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _tl:TimelineLite;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:ParsedGameData):void {
    }

    protected disbaleOverlays():boolean{
        return ((SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.RESPIN && SpacierArcadeModeData.instance.nextMode !== SpacierArcadeGameMode.RESPIN)
            || (SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.FREESPIN_RESPIN && SpacierArcadeModeData.instance.nextMode !== SpacierArcadeGameMode.FREESPIN_RESPIN) ||
            (SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.FREESPIN && (SpacierArcadeModeData.instance.nextMode === SpacierArcadeGameMode.FREESPIN || SpacierArcadeModeData.instance.nextMode === SpacierArcadeGameMode.NORMAL))
        );
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        this._tl = new TimelineLite();

        if(this.hasWin(data)){
            this._tl.add(SpacierArcadeGameModuleConfig.spacierArcadeOverlayView.getNewStickySymbols(data.newOverlaySymbols, data.overlayWildsMultipliers, data.spinIntensity));
        }
        if(this.disbaleOverlays()) {
            this._tl.add(SpacierArcadeGameModuleConfig.spacierArcadeOverlayView.abortDisableOverlayWilds(data.overlayWildsMultipliers));
        }
        return this._tl;
    }

    //to fix production issue #335
    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
        this._tl?.progress(100);
        return null;
    }
    // public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
    //     if(isActive && this._tl) {
    //         return this._tl;
    //     }
    //     return this.getAnimation(data);
    // }

    protected hasWin(data:SpacierArcadeParsedGameData):boolean{
        return ((SpacierArcadeModeData.instance.nextMode === SpacierArcadeGameMode.RESPIN || SpacierArcadeModeData.instance.nextMode === SpacierArcadeGameMode.FREESPIN_RESPIN ||
            SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.RESPIN || SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.FREESPIN_RESPIN) &&
            (SpacierArcadeModeData.instance.nextMode !== SpacierArcadeGameMode.NORMAL || SpacierArcadeModeData.instance.nextMode !== SpacierArcadeGameMode.FREESPIN)
            && this.hasNewOverlays(data.newOverlaySymbols));
    }

    private hasNewOverlays(newOverlaySymbols:string[][]):boolean{
        let returnValue:boolean = false;
        if(newOverlaySymbols.length > 0){
            newOverlaySymbols.forEach((item) => {
                item.forEach((subItem) => {
                    if(subItem !== null){
                        returnValue = true;
                        return;
                    }
                });
            });
        }
        return returnValue;
    }
}